module.exports = __webpack_public_path__ + "static/img/Villaya-Microgrids.65c9b64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/Villaya-Microgrids.jpg
// module id = mgoh
// module chunks = 0